module.exports = __webpack_public_path__ + "media/images/client-wessex-f99a27ffcddf9b0add597ee7461a40c4.svg";